RivalIQ.module('landscape.views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.CompanyAddResult = Marionette.ItemView.extend({
        template: '#blankRecommendationItem',

        ui: {
            companyIcon: 'img.x-icon',
            companyAbbr: '.x-hero-logo'
        },

        events: {
            'click .x-follow-btn': 'followCompany',
            'click .x-remove': 'unFollowCompany',
            'click .x-suggestion': 'suggestionClicked',
            'click .x-clear-btn': 'clearClicked'
        },

        hideIconsAndDescriptions: function () {
            const me = this;

            me.$('.x-desc-icon-twitter').hide();
            me.$('.x-desc-icon-facebook').hide();
            me.$('.x-desc-icon-instagram').hide();
            me.$('.x-desc-icon-globe').hide();
            me.$('.x-desc-icon-question').hide();
        },

        initialize: function (options) {

            const me = this;
            const opts = options || {};

            _.extend(me, {
                options: opts
            }, _.pick(opts, 'enableFollow', 'pubsub'));

            me.companyIcon = RivalIQ.utils.companyDisplay.getIcon(me.options.data);

            //figure out the overview
            if (RivalIQ.utils.companyDisplay.hasTwitter(me.options.data)) {

                me.overview = RivalIQ.utils.companyDisplay.getDescription(me.options.data);
                me.setupIcon = function () {
                    me.hideIconsAndDescriptions();
                    me.$('.x-desc-icon-twitter').show();
                    RivalIQ.utils.tooltip.addTooltip(me.$('.x-desc-icon-twitter'), {
                        title: 'Twitter Description'
                    });
                };
            } else if (RivalIQ.utils.companyDisplay.hasFacebook(me.options.data)) {

                me.overview = RivalIQ.utils.companyDisplay.getDescription(me.options.data);
                me.setupIcon = function () {
                    me.hideIconsAndDescriptions();
                    me.$('.x-desc-icon-facebook').show();
                    RivalIQ.utils.tooltip.addTooltip(me.$('.x-desc-icon-facebook'), {
                        title: 'Facebook Description'
                    });
                };
            } else if (RivalIQ.utils.companyDisplay.hasInstagram(me.options.data)) {

                me.overview = RivalIQ.utils.companyDisplay.getDescription(me.options.data);
                me.setupIcon = function () {
                    me.hideIconsAndDescriptions();
                    me.$('.x-desc-icon-instagram').show();
                    RivalIQ.utils.tooltip.addTooltip(me.$('.x-desc-icon-instagram'), {
                        title: 'Instagram Description'
                    });
                };
            } else if (RivalIQ.utils.companyDisplay.hasYouTube(me.options.data)) {

                me.overview = RivalIQ.utils.companyDisplay.getDescription(me.options.data);
                me.setupIcon = function () {
                    me.hideIconsAndDescriptions();
                    me.$('.x-desc-icon-youtube').show();
                    RivalIQ.utils.tooltip.addTooltip(me.$('.x-desc-icon-youtube'), {
                        title: 'YouTube Description'
                    });
                };
            } else if (RivalIQ.utils.companyDisplay.hasTiktok(me.options.data)) {

                me.overview = RivalIQ.utils.companyDisplay.getDescription(me.options.data);
                me.setupIcon = function () {
                    me.hideIconsAndDescriptions();
                    me.$('.x-desc-icon-tiktok').show();
                    RivalIQ.utils.tooltip.addTooltip(me.$('.x-desc-icon-tiktok'), {
                        title: 'TikTok Description'
                    });
                };
            } else if (RivalIQ.utils.companyDisplay.hasDomain(me.options.data)) {

                me.overview = RivalIQ.utils.companyDisplay.getDescription(me.options.data);
                me.setupIcon = function () {
                    me.hideIconsAndDescriptions();
                    me.$('.x-desc-icon-globe').show();
                    RivalIQ.utils.tooltip.addTooltip(me.$('.x-desc-icon-globe'), {
                        title: 'Description from Home Page'
                    });
                };
            } else if (me.options.data.homepagetitle && !me.options.data.homepagetitle.match(/^\s*$/)) {

                me.overview = me.options.data.homepagetitle;
                me.setupIcon = function () {
                    me.hideIconsAndDescriptions();
                    me.$('.x-desc-icon-globe').show();
                    RivalIQ.utils.tooltip.addTooltip(me.$('.x-desc-icon-globe'), {
                        title: 'Title from Home Page'
                    });
                };
            } else {
                me.overview = 'We found the web site you added, but we were unable to extract any overview information.';
                me.setupIcon = function () {
                    me.hideIconsAndDescriptions();
                    me.$('.x-desc-icon-question').show();
                    RivalIQ.utils.tooltip.addTooltip(me.$('.x-desc-icon-question'), {
                        title: 'No overview found'
                    });
                };
            }
        },

        serializeData: function () {
            const me = this;
            const options = me.options;
            const data = options.data;

            data.enableClearButton = options.enableClearButton;
            data.clearButtonText = options.clearButtonText;
            data.abbr = RivalIQ.utils.companyDisplay.getAbbreviation(data);

            return data;
        },

        onRender: function () {
            const me = this;
            const options = me.options;
            const data = me.serializeData();
            let name = data.name;
            const primaryDomain = RivalIQ.utils.companyDisplay.getPrimaryDomainRecord(data);

            if (primaryDomain && primaryDomain.presence && primaryDomain.presence.source) {

                name += ` (${primaryDomain.presence.source})`;
            }

            me.$el.attr('id', '');

            if (!me.enableFollow) {
                me.$('.x-follow-btn').remove();
            }

            if (options.disableUnfollow) {

                me.$('.close').remove();
            }

            // NOTE don't suggest using the base website if the URL was to a social handle
            if (data.suggestion && !RivalIQ.utils.socialUrl.isSocialUrl(data.url)) {

                me.$('.x-suggestion').removeClass('hide')
                    .find('strong').text(data.suggestion);
            }

            me.$('.x-company-name').html(name);

            me.ui.companyIcon.attr('src', me.companyIcon);
            if (me.companyIcon) {
                me.ui.companyIcon.show();
                me.ui.companyAbbr.hide();
            } else {
                me.ui.companyIcon.hide();
                me.ui.companyAbbr.show();
            }

            me.$('.x-description').html(me.overview);
            me.setupIcon();

            me.$el.show();
        },

        followCompany: function () {
            const me = this;
            const data = Marionette.getOption(me, 'data');
            me.trigger('follow', data);
        },

        unFollowCompany: function () {
            const me = this;
            const data = Marionette.getOption(me, 'data');
            me.trigger('unfollow', data);
        },

        suggestionClicked: function () {
            const me = this;

            if (!me.options.disableUnfollow) {
                me.unFollowCompany();
            }

            me.pubsub.trigger('suggestion-selected', me.options.data.suggestion);
        },

        clearClicked: function (e) {
            const me = this;
            me.pubsub.trigger('clear-button-clicked', e);
        }
    });

});
